export const items = [
  {
    id: 1,
    name: "iPhone 14 Pro Max",
    image: "https://m.media-amazon.com/images/I/610pghkO81L._SX679_.jpg",
  },
  {
    id: 2,
    name: "Canon 200D",
    image: "https://m.media-amazon.com/images/I/914hFeTU2-L._SX450_.jpg",
  },
  {
    id: 3,
    name: "Macbook Air",
    image: "https://m.media-amazon.com/images/I/71eXNIDUGjL._SX679_.jpg",
  },
  {
    id: 4,
    name: "Samsung S23",
    image: "https://m.media-amazon.com/images/I/61RZDb2mQxL._SX679_.jpg",
  },
];

export const itemDetailsData = [
  {
    id: "1",
    name: "iPhone 14 Pro Max",
    image: "https://m.media-amazon.com/images/I/610pghkO81L._SX679_.jpg",
    specs: [
      "15.40 cm (6.1-inch) Super Retina XDR display",
      "Advanced camera system for better photos in any light",
      "Cinematic mode now in 4K Dolby Vision up to 30 fps",
      "Action mode for smooth, steady, handheld videos",
      "Vital safety technology — Crash Detection calls for help when you can’t"
    ],
    description:
      "The iPhone 14 Pro, released in 2023, features an edge-to-edge OLED display and a powerful A14 Bionic chip, providing faster performance and better battery life than its predecessors. It introduced Face ID technology, which allows users to unlock their phone and authenticate transactions with facial recognition. The device also features a dual-lens camera system with improved portrait mode and optical zoom capabilities."
  },
  {
    id: "2",
    name: "Canon 200D",
    image: "https://m.media-amazon.com/images/I/914hFeTU2-L._SX450_.jpg",
    specs: [
      "Color: Black",
      "Cutting-edge technology",
      "Best-in class Performance",
      "Compatible Mountings: Canon Ef-S; Photo Sensor Technology: Cmos; Hardware Interface: Secure Digital"
    ],
    description:
      "The Canon 200D, also known as the Rebel SL2, is a compact DSLR camera released in 2017. It features a 24.2 megapixel APS-C sensor and a DIGIC 7 image processor, allowing for improved image quality and faster processing speeds. The camera has a 9-point autofocus system and Dual Pixel CMOS AF technology, which provides accurate and smooth focusing during both photos and videos. It also has a vari-angle touchscreen display and Wi-Fi/NFC connectivity for easy sharing and remote control of the camera."
  },
  {
    id: "3",
    name: "Macbook Air",
    image: "https://m.media-amazon.com/images/I/71eXNIDUGjL._SX679_.jpg",
    specs: [
      "All-Day Battery Life – Go longer than ever with up to 18 hours of battery life.",
      "Powerful Performance – Take on everything from professional-quality editing to action-packed gaming with ease.",
      "The Apple M1 chip with an 8-core CPU delivers up to 3.5x faster performance than the previous generation while using way less power.",
      "Superfast Memory – 8GB of unified memory makes your entire system speedy and responsive.",
      "Stunning Display – With a 13.3-inch/33.74 cm Retina display, images come alive with new levels of realism."
    ],
    description:
      "The MacBook Air is a popular and lightweight laptop computer produced by Apple. It features a thin and durable aluminum body, with a 13.3-inch Retina display and an M1 chip for fast and efficient performance. The device also has a backlit Magic Keyboard and Touch ID for easy and secure access to the system. The MacBook Air is equipped with up to 16GB of RAM and up to 2TB of storage, making it a suitable choice for a variety of tasks, from web browsing to video editing."
  },
  {
    id: "4",
    name: "Samsung S23",
    image: "https://m.media-amazon.com/images/I/61RZDb2mQxL._SX679_.jpg",
    specs: [
      "More light for your night - Get ready for a Gallery full of epic night shots everyone will want. Nightography's enhanced AI keeps details clear, so low light photos and videos will be bright and colorful from dusk to dawn and back again.",
      "Designed with the planet in mind - Unbox the change you want to see in the world. Crafted with recycled glass and PET film and colored with natural dyes, each phone is tucked into a box made of recycled paper and paper-based protective film.",
      "Power for those who don't pause - Your quest for epic mobile gaming is over. Snapdragon 8 Gen 2 Mobile Platform for Galaxy optimizes and streamlines your device for silky smooth games —without draining the battery."
    ],
    description:
      "The Samsung Galaxy S23 is a high-end smartphone released in 2023. It features a 6.2-inch Dynamic AMOLED display with a 120Hz refresh rate and a resolution of 1080 x 2400 pixels, providing vibrant colors and smooth scrolling. The device is powered by the Exynos 2100 or Snapdragon 888 chipset, depending on the region, and has up to 16GB of RAM and up to 512GB of storage. The camera system includes a 12MP wide, 64MP telephoto, and 12MP ultra-wide lens, as well as 8K video recording capabilities. The phone also has 5G connectivity, an in-display fingerprint sensor, and a 5,000mAh battery with fast charging and wireless charging capabilities."
  }
];

